var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoParentalRatingGeneric = function SvgIcoParentalRatingGeneric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#80FF00",
    d: "M12 24c6.627 0 12-5.372 12-12S18.627 0 12 0 0 5.372 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.051 4.793c3.968 0 7.198 3.228 7.198 7.197s-3.23 7.197-7.198 7.197-7.197-3.229-7.197-7.197 3.229-7.197 7.197-7.197m0-2.399a9.595 9.595 0 0 0-9.596 9.596c0 5.3 4.296 9.596 9.596 9.596s9.596-4.296 9.596-9.596-4.296-9.596-9.596-9.596"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcoParentalRatingGeneric;